import React, { forwardRef, useState } from 'react';
import { DataFilter, DialogContent, DialogOptions } from './styled';
import { Button, Icon } from 'react-materialize';
import InputMask from 'react-input-mask';
import ReactDatePicker from 'react-datepicker';
import { ptBR } from 'date-fns/locale';
import { alerta, formataMoedaPFloat, formatFloatBr } from '../../../services/funcoes';
import { IoMdAdd } from 'react-icons/io';
import { FaTrash } from 'react-icons/fa';

const CustomCalendarInput = forwardRef(({ value, onClick, onChange }, ref) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'row',
      width: '130px',
      justifyContent: 'space-around',
      borderBottom: '1px solid #ccc',
      zIndex: '50 !important',
    }}
  >
    <InputMask
      style={{ width: '100px', zIndex: '50 !important' }}
      mask="99/99/9999"
      value={value}
      maskChar={null}
      onChange={onChange}
    />
    <span onClick={onClick} style={{ cursor: 'pointer', color: 'rgb(97, 9, 138)' }}>
      <Icon>date_range</Icon>
    </span>
  </div>
));

export function DialogInstallments({ handleSave, data, discounts, handleClose, existInstallments }) {
  const [inputs, setInputs] = useState(existInstallments ? data.PAGAMENTOS || [] : []);

  function addInputs() {
    const currentDate = new Date();
    const newDate = new Date(currentDate);

    if (inputs.length > 0) {
      newDate.setMonth(newDate.getMonth() + inputs.length);
    }
    setInputs([...inputs, { APG_DTA_VENCIMENTO: newDate, APG_VALOR: null }]);
  }

  function handleSaveInstallments() {
    const filteredData = inputs.filter((item) => item.APG_VALOR !== null && item.APG_VALOR !== 0);
    const valueTotal = filteredData.reduce(
      (accumulator, currentValue) => formataMoedaPFloat(accumulator) + formataMoedaPFloat(currentValue.APG_VALOR),
      0
    );

    if (formataMoedaPFloat(valueTotal) !== formataMoedaPFloat(data.ATD_VALOR_TOTAL)) {
      alerta('O valor das parcelas é diferente do valor total', 2);
      return;
    }

    handleSave(filteredData);
  }

  return (
    <DialogOptions>
      <DialogContent>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button
            onClick={handleClose}
            style={{
              border: 'none',
              padding: '0.5rem',
              borderRadius: '100%',
              color: '#FFF',
              background: '#8e44ad',
              fontSize: '1.1rem',
              width: '40px',
              height: '40px',
            }}
          >
            X
          </button>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.2rem' }}>
          <p style={{ padding: '0 0.2rem', fontSize: '1rem', marginBottom: '0.5rem' }}>
            <strong>Valor total: </strong> {formatFloatBr(formataMoedaPFloat(data.ATD_VALOR_TOTAL))}
          </p>
          <p style={{ padding: '0 0.2rem', fontSize: '1rem', marginBottom: '0.5rem' }}>
            <strong>Descontos: </strong> {formatFloatBr(formataMoedaPFloat(discounts || 0))}
          </p>
          <p style={{ padding: '0 0.2rem', fontSize: '1rem', marginBottom: '0.5rem' }}>
            <strong>Valor final: </strong>{' '}
            {formatFloatBr(formataMoedaPFloat(data.ATD_VALOR_TOTAL) - formataMoedaPFloat(discounts || 0))}
          </p>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.3rem' }}>
          {inputs.map((input, index) => (
            <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
              <span style={{ fontSize: '1.2rem', fontWeight: '700', marginRight: '0.5rem' }}>{index + 1}ª</span>
              <DataFilter style={{ flexWrap: 'wrap' }}>
                <ReactDatePicker
                  id="startDate"
                  selected={new Date(input.APG_DTA_VENCIMENTO)}
                  onChange={(e) => {
                    if (e <= inputs[index - 1]?.APG_DTA_VENCIMENTO) {
                      alerta('Data inválida', 2);
                      return;
                    }
                    const updatedInputs = [...inputs];
                    updatedInputs[index].APG_DTA_VENCIMENTO = e;
                    setInputs(updatedInputs);
                  }}
                  locale={ptBR}
                  placeholderText="Data"
                  dateFormat="dd/MM/yyyy"
                  selectsStart
                  startDate={input.APG_DTA_VENCIMENTO}
                  customInput={<CustomCalendarInput />}
                />
              </DataFilter>
              <input
                type="text"
                placeholder="Valor da parcela"
                value={input.APG_VALOR}
                id={`Input ${index * 2 + 2}`}
                onChange={(event) => {
                  const valor = event.target.value;
                  let v = String(valor).replace(/\D/g, '');

                  v = (Number(v) / 100).toFixed(2).toString();

                  v = v.replace('.', ',');

                  v = v.replace(/(\d)(\d{3})(\d{3}),/g, '$1.$2.$3,');

                  v = v.replace(/(\d)(\d{3}),/g, '$1.$2,');
                  const updatedInputs = [...inputs];
                  updatedInputs[index].APG_VALOR = v;
                  setInputs(updatedInputs);
                  event.target.value = `R$ ${v}`;
                }}
              />
              <button
                style={{
                  border: 'none',
                  padding: '0.5rem',
                  borderRadius: '100%',
                  color: '#FFF',
                  background: 'red',
                  width: '26px',
                  height: '26px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                onClick={() => {
                  const updatedInputs = inputs.filter((e) => e !== input);
                  setInputs(updatedInputs);
                }}
              >
                <FaTrash size={18} />
              </button>
            </div>
          ))}
        </div>
        <Button
          style={{ zIndex: 'unset' }}
          className="waves-effect waves-light saib-button is-primary"
          onClick={addInputs}
        >
          <IoMdAdd size={18} />
          Adicionar nova parcela
        </Button>
        <Button
          disabled={inputs.length === 0}
          onClick={handleSaveInstallments}
          className="waves-effect waves-light saib-button is-primary"
          style={{ zIndex: 'unset' }}
        >
          Salvar
        </Button>
      </DialogContent>
    </DialogOptions>
  );
}
